import { redirect } from "@tanstack/react-router";

import {
  reportAccessDenied,
  type RouteAccessRequirement,
  type RouteGuardContext,
} from "@/core/lib/observability";

// every permission gate on a route ends here, so a refused visit always lands
// on the same page and leaves a trace in faro instead of silently bouncing
export function denyRouteAccess(
  guard: RouteGuardContext,
  requirement: RouteAccessRequirement,
): never {
  reportAccessDenied(guard, requirement);
  throw redirect({ to: "/not-authorized" });
}
